// Home (carregado só nela, em layout/theme.liquid).
// 1. Banners (sections/body-banners.liquid): rolagem com encaixe (o dedo arrasta), setas,
//    bolinhas e troca automática que pausa quando a pessoa interage.
// 2. Linhas que rolam de lado com setas (objetivos): [data-bh-rolagem] e [data-bh-rolar].
// 3. Prévia muda dos vídeos (sections/body-videos-depoimentos.liquid), como no SuperCoffee.
(() => {
  document.querySelectorAll('[data-bh-banners]').forEach((raiz) => {
    if (raiz.dataset.ligado) return;
    raiz.dataset.ligado = '1';
    const trilho = raiz.querySelector('[data-bh-trilho]');
    const slides = [...trilho.children];
    const dots = [...raiz.querySelectorAll('.bh-banners__dot')];
    if (slides.length < 2) return;
    const atual = () => Math.round(trilho.scrollLeft / trilho.clientWidth);
    // Banners 2 em diante só baixam quando chega a vez deles (ou quando a pessoa mexe no carrossel).
    const carregar = (slide) => {
      slide?.querySelectorAll('[data-srcset]').forEach((e) => { e.srcset = e.dataset.srcset; e.removeAttribute('data-srcset'); });
      // loading="lazy" vira eager: o slide está de lado, fora da tela, e o navegador só baixaria quando ele já estivesse aparecendo (banner vazio na troca).
      slide?.querySelectorAll('img[data-src]').forEach((e) => { e.loading = 'eager'; e.src = e.dataset.src; e.removeAttribute('data-src'); });
    };
    const carregarTodos = () => slides.forEach(carregar);
    const ir = (i) => {
      const n = (i + slides.length) % slides.length;
      carregar(slides[n]);
      trilho.scrollTo({ left: n * trilho.clientWidth, behavior: 'smooth' });
    };
    const marcar = () => {
      const i = atual();
      dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      slides.forEach((s, k) => { if (k === i) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1'); });
    };
    let pausa = false;
    raiz.addEventListener('click', (e) => {
      const p = e.target.closest('[data-passo]');
      const d = e.target.closest('[data-ir]');
      if (p) { pausa = true; ir(atual() + Number(p.dataset.passo)); }
      if (d) { pausa = true; ir(Number(d.dataset.ir)); }
    });
    let espera;
    trilho.addEventListener('scroll', () => { clearTimeout(espera); espera = setTimeout(marcar, 80); }, { passive: true });
    ['pointerdown', 'focusin', 'mouseenter', 'touchstart'].forEach((ev) => raiz.addEventListener(ev, () => { pausa = true; carregarTodos(); }, { passive: true }));
    raiz.addEventListener('mouseleave', () => { pausa = false; });
    const intervalo = Number(raiz.dataset.intervalo || 0) * 1000;
    if (intervalo > 0 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Na hora da troca baixa o próximo e só passa quando ele chegar (no máximo 2 s), para não mostrar banner vazio.
      setInterval(() => {
        if (pausa || document.hidden) return;
        const alvo = atual() + 1;
        const prox = slides[alvo % slides.length];
        carregar(prox);
        const img = prox.querySelector('img');
        if (!img || img.complete) return ir(alvo);
        let foi = false;
        const passar = () => { if (!foi) { foi = true; ir(alvo); } };
        img.addEventListener('load', passar, { once: true });
        setTimeout(passar, 2000);
      }, intervalo);
    }
    marcar();
  });

  document.querySelectorAll('[data-bh-rolagem]').forEach((lista) => {
    const caixa = lista.parentElement;
    const setas = [...caixa.querySelectorAll('[data-bh-rolar]')];
    const atualizar = () => {
      const fim = lista.scrollWidth - lista.clientWidth;
      setas.forEach((b) => { b.hidden = fim < 4 || (b.dataset.bhRolar === '-1' ? lista.scrollLeft < 4 : lista.scrollLeft > fim - 4); });
    };
    setas.forEach((b) => b.addEventListener('click', () => lista.scrollBy({ left: Number(b.dataset.bhRolar) * lista.clientWidth * 0.7, behavior: 'smooth' })));
    lista.addEventListener('scroll', atualizar, { passive: true });
    addEventListener('resize', atualizar, { passive: true });
    atualizar();
  });

  // 3. Prévia muda: só baixa quando o card aparece na tela (nunca na abertura da página), usa a
  // versão mp4 mais leve, toca no máximo 3 de cada vez e pausa o que sai da tela.
  // Não roda com economia de dados, conexão lenta ou "reduzir movimento".
  const rede = navigator.connection;
  const poupar = rede?.saveData || /(^|-)2g$/.test(rede?.effectiveType || '') || matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cards = [...document.querySelectorAll('.bh-videos__item[data-previa]')];
  if (cards.length && !poupar && 'IntersectionObserver' in window) {
    const tocando = new Set();
    const tocar = (card) => {
      let v = card.querySelector('.bh-videos__previa');
      if (!v) {
        v = document.createElement('video');
        v.className = 'bh-videos__previa';
        v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
        v.setAttribute('aria-hidden', 'true');
        v.addEventListener('playing', () => v.classList.add('is-pronta'), { once: true });
        v.addEventListener('error', () => { tocando.delete(v); v.remove(); delete card.dataset.previa; }, { once: true });
        v.src = card.dataset.previa;
        card.querySelector('.bh-videos__capa')?.after(v);
      }
      if (tocando.size >= 3 && !tocando.has(v)) return;
      tocando.add(v);
      v.play().catch(() => tocando.delete(v));
    };
    const parar = (card) => {
      const v = card.querySelector('.bh-videos__previa');
      if (v) { v.pause(); tocando.delete(v); }
    };
    const io = new IntersectionObserver((itens) => itens.forEach((e) => (e.isIntersecting ? tocar(e.target) : parar(e.target))), { threshold: 0.6 });
    cards.forEach((c) => io.observe(c));
    // Ao abrir o player, as prévias param para não disputar a conexão com o vídeo de verdade.
    document.addEventListener('click', (e) => { if (e.target.closest('[data-body-reel]')) cards.forEach(parar); });
  }
})();

// 4. Fotos das avaliações do Google: o carregamento sob demanda (data-lazy-src) passou para a própria seção
// (sections/body-avaliacoes-google.liquid) em 05/10/2026, para valer também em produto e coleção.
